export const PLAY_NOTIFICATIONS = 'NOTIFICATIONS'
export const CLOSE_NOTIFICATIONS = 'NOTIFICATIONS'
